module.exports = __webpack_public_path__ + "img/23_99.9b644f5f.png";